import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import { thousandSeperator } from "@utils/general/digit-separators";
import OutlinedStatus from "@components/status/OutlinedStatus";
import { TSecondarySaleOrder } from "@helpers/validation-schemas/primary-sale-order/sale-order.schema";
import { formatDate } from "@utils/general/format-date";
import AuthComponent from "@components/auth/component";
import { wrap } from "module";

export const saleOrderColumns = (
  editHandler: (
    id: string | number,
    status: string | number,
    payment_type_id: string | number
  ) => void,
  deleteHandler: () => void
) => [
  {
    name: "No",
    selector: (row: any) => (!isNaN(row.no) ? row.no + 1 : row.no),
    width: "10ch",
  },
  {
    name: "Sale Order Id",
    selector: (row: TSecondarySaleOrder) => (
      <div className="font-semibold text-primary-dark">
        {row.secondary_sales_order_code}
      </div>
    ),
    width: "25ch",
    // sortable: true,
  },
  {
    name: "Sales Date",
    selector: (row: TSecondarySaleOrder) =>
      row.sales_date && formatDate(new Date(row.sales_date)),
    // row.formatted_sales_date
    // sortable: true,
    wrap: true,
    width: "15ch",
  },
  {
    name: "Customer Name",
    selector: (row: TSecondarySaleOrder) =>
      //@ts-ignore
      row.no !== "Totals:" && (
        <div className="font-semibold text-primary-dark">
          {row.customer_first_name + " " + (row.customer_last_name || " ")}
        </div>
      ),
    // sortable: true,
    wrap: true,
    width: "15ch",
  },
  {
    name: "Business Unit Name",
    selector: (row: TSecondarySaleOrder) =>
      //@ts-ignore
      row.no !== "Totals:" && (
        <div className="font-semibold text-primary-dark">
          {row?.business_unit_name || "-"}
        </div>
      ),
    width: "15ch",

    // sortable: true,
    wrap: true,
  },

  {
    name: "Payment Type",
    selector: (row: TSecondarySaleOrder) => row.payment_type_name,
    wrap: true,
    // sortable: true,
  },
  {
    name: "Status",
    selector: (row: TSecondarySaleOrder) =>
      //@ts-ignore
      row.no !== "Totals:" && (
        <OutlinedStatus
          width="w-fit"
          color={
            row.status == 1
              ? "blue"
              : row.status == 2
              ? "green"
              : row.status == 3
              ? "purple"
              : row.status == 4
              ? "red"
              : "orange"
          }
          title={
            row.status == 1
              ? "Open"
              : row.status == 2
              ? "Invoice Created"
              : row.status == 3
              ? "Approved & Open"
              : row.status == 4
              ? "Rejected"
              : "Closed"
          }
        />
      ),
    // grow: 2,
    width: "20ch",

    // sortable: true,
  },
  {
    name: "Grand Total Amount",
    selector: (row: TSecondarySaleOrder) =>
      //@ts-ignore
      thousandSeperator(Number(row.grand_total_amount) || 0),
    // sortable: true,
    grow: 2,
  },
  {
    name: "Action",
    right: "true",
    selector: (row: TSecondarySaleOrder) =>
      //@ts-ignore
      !row.noAction ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <AuthComponent
            action="edit"
            module="Primary Sale Order"
            subModule="Primary Sale Order"
          >
            <EditButton
              disabled={row.status == 2}
              id={row.secondary_sales_order_id}
              actionHandler={() =>
                editHandler(
                  row.secondary_sales_order_id,
                  row.status,
                  row.payment_type_id
                )
              }
            />
          </AuthComponent>

          <AuthComponent
            action="delete"
            module="Primary Sale Order"
            subModule="Primary Sale Order"
          >
            <DeleteButton
              id={row.secondary_sales_order_id}
              actionHandler={deleteHandler}
              disabled={row.status == 2}
            />
          </AuthComponent>
        </div>
      ) : null,
  },
];
